module.exports = __webpack_public_path__ + "img/836000951_4.b3d1ac85.jpg";